import React from 'react';
import { useNumberInput } from '../lib/useNumberInput';

export default function GridNum({ value, onChange, className = '', testId }) {
  const { raw, handleChange, handleBlur } = useNumberInput(value, onChange);
  return (
    <input
      type="text"
      inputMode="decimal"
      data-testid={testId}
      className={
        'num-input px-2 py-1 border border-transparent hover:border-slate-200 focus:border-[#2FA163] focus:ring-1 focus:ring-[#2FA163]/50 rounded text-sm text-right ' +
        className
      }
      value={raw}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}
